class FlatOrderDto {
    constructor(sampleObject) {
        var so = sampleObject;
        this.programId = so.programId;
        this.programType = so.programType;
        this.isProgressive = so.isProgressive;
        this.termsPageName = so.termsPageName;
        this.couponCode = so.couponCode;
        this.supplierName = so.supplierName;
        this.uncut = so.uncut;
        this.LabSuppliedFrame = so.isLabSuppliedFrame;
        this.NVB = so.NVB;
        this.WrapAngle = so && so.WrapAngle != null ? so.WrapAngle.toString() : null;
        this.SPBaseCurve = so && so.SPBaseCurve != null ? so.SPBaseCurve.toString() : null;
        this.PantoAngle = so && so.PantoAngle != null ? so.PantoAngle.toString() : null;
        this.RightVertexDistance = so && so.RightVertexDistance != null ? so.RightVertexDistance.toString() : null;
        this.LeftVertexDistance = so && so.LeftVertexDistance != null ? so.LeftVertexDistance.toString() : null;
        this.Initials = so && so.Initials != null ? so.Initials.toString() : null; 
        this.LensOnly = so && so.LensOnly ? so.LensOnly: false;                                          
        if (so.isLabSuppliedFrame) {
            this.LabSupplyUPC = so.labSuppliedFrame.upc;
            this.manufacturer = null;
            this.model  = null;
            this.color = null;
            this.type  = null;
            this.aBox  = null;
            this.bBox  = null;
            this.templeLength  = null;
            this.dbl  = null;
        } else {
            this.LabSupplyUPC = so.upc;
        }
      
        //shipping
        this.name = so.name != null ? so.name : so.firstName + ' ' + so.lastName;
        this.addressLine1 = so.addressLine1;
        this.addressLine2 = so.addressLine2;
        this.city = so.city;
        this.region = so.region;
        this.postalCode = so.postalCode;
        this.phone = so.phone;
        this.mobilePhone = so.mobilePhone;
        this.email = so.email;

        //frame for FTC
        this.manufacturer = so.manufacturer;
        this.model = so.model;
        this.color = so.color;
        this.type = so.type;
        this.aBox = so.aBox;
        this.bBox = so.bBox;
        this.templeLength = so.templeLength;
        this.dbl = so.dbl;

        this.freeEntry1  = so.freeEntry1;
        this.freeEntry2  = so.freeEntry2;
        this.freeEntry3  = so.freeEntry3;
        this.freeEntry4  = so.freeEntry4;
        this.freeEntry5  = so.freeEntry5;

        //RX
        this.firstName = so.firstName;
        this.lastName = so.lastName;
        this.currentLens = so.currentLens;
        this.practiceName = so.practiceName;
        this.role = so.role;

        //RX OD
        this.resph = so.resph;
        this.recyl = so.recyl;
        this.reaxis = so.reaxis;
        this.readd = so.readd;
        this.rehorizPrismValue = so.rehorizPrismValue;
        this.rehorizPrismDirection = so.rehorizPrismDirection;
        this.reverticalPrismValue = so.reverticalPrismValue;
        this.reverticalPrismDirection = so.reverticalPrismDirection;
        this.redistPD = so.redistPD;
        this.resegHeight = so.resegHeight;

        //RX OS
        this.lesph = so.lesph;
        this.lecyl = so.lecyl;
        this.leaxis = so.leaxis;
        this.leadd = so.leadd;
        this.lehorizPrismValue = so.lehorizPrismValue;
        this.lehorizPrismDirection = so.lehorizPrismDirection;
        this.leverticalPrismValue = so.leverticalPrismValue;
        this.leverticalPrismDirection = so.leverticalPrismDirection;
        this.ledistPD = so.ledistPD;
        this.lesegHeight = so.lesegHeight;
    
        this.acceptedTerms = so.acceptedTerms;
        this.treatment = so.treatment;
        this.material = so.material;
        this.design = so.design;
        this.photochromic = so.photochromic;
        this.tint = so.tint;
        this.tintColor = so.tintColor;
    }
}


export default FlatOrderDto;
